export default function AuthTextField({
  value,
  onChange,
  placeholder,
  maxLength,
  error,
  errorText,
  className = '',
  ...props
}) {
  return (
    <div className={`w-full ${className}`}>
      <input
        type="text"
        value={value}
        onChange={(e) => onChange?.(e.target.value)}
        placeholder={placeholder}
        maxLength={maxLength}
        className={`box-border w-full rounded-[5px] border border-solid bg-[rgba(255,255,255,0.5)] px-5 py-4 font-['Pretendard'] text-[16px] text-black outline-none placeholder:text-gray03 ${
          error ? 'border-[#E05A5A]' : 'border-[rgba(139,104,221,0.3)]'
        }`}
        {...props}
      />
      {error && errorText ? <p className="mt-2 px-1 text-[12px] leading-[16px] text-[#E05A5A]">{errorText}</p> : null}
    </div>
  );
}
